import { useState } from 'react';
import { useLang } from '../../../i18n/LanguageContext';

export default function Certification() {
  const { t } = useLang();
  const [showModal, setShowModal] = useState(false);

  return (
    <section id="certification" className="py-24 px-4 sm:px-8 bg-gradient-to-b from-[#1a0b2e] via-[#2d1b4e] to-[#1a0b2e] relative overflow-hidden">
      {/* 背景装饰光晕 */}
      <div className="absolute top-1/3 left-1/4 w-96 h-96 bg-[#d4af37]/5 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-1/3 right-1/4 w-80 h-80 bg-[#c8b6ff]/5 rounded-full blur-3xl pointer-events-none"></div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-16 items-center mb-20">
          <div className="space-y-8">
            <div className="inline-flex items-center space-x-2 px-4 py-2 bg-[#d4af37]/20 rounded-full border border-[#d4af37]/30">
              <span className="text-[#d4af37] text-sm font-medium">{t('Professional Certificate', '专业证书')}</span>
            </div>

            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6 bg-gradient-to-r from-[#d4af37] via-[#c8b6ff] to-[#d4af37] bg-clip-text text-transparent">
              {t('Professional Certification Programs', '专业认证课程')}
            </h2>

            <p className="text-xl text-[#c8b6ff] leading-relaxed">
              {t('After completing the course, you will receive a certificate of completion', '完成课程后，通过专业考试，您将获得专业认证的结业证书')}
            </p>

            <div className="space-y-4">
              {[
                {
                  en: 'Lifetime Valid Certificate',
                  zh: '终身有效证书',
                  descEn: 'Permanently valid and verifiable',
                  descZh: '永久有效，认证可查',
                },
                {
                  en: 'Career Development Support',
                  zh: '职业发展支持',
                  descEn: 'Employment guidance and entrepreneurship support programs',
                  descZh: '就业指导与创业扶持计划',
                },
                {
                  en: 'Continuing Education Resources',
                  zh: '持续教育资源',
                  descEn: 'Free Course Review &amp; Exclusive Discounts for Students',
                  descZh: '免费复训&学院课程学员专享优惠',
                },
              ].map((item) => (
                <div key={item.en} className="flex items-start space-x-4">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-checkbox-circle-fill text-2xl text-[#d4af37]"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-white mb-1">{t(item.en, item.zh)}</h4>
                    <p className="text-[#c8b6ff]">{t(item.descEn, item.descZh)}</p>
                  </div>
                </div>
              ))}
            </div>


          </div>

          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl border-2 border-[#d4af37]/30">
              <img
                src="https://static.readdy.ai/image/f4ea41724fdff553620ff2345610d616/a02b4a2775ba32105ca42466c229f38d.png"
                alt="Certification"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#2d1b4e]/40 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>

      {/* 证书放大模态框 */}
      {showModal && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4"
          onClick={() => setShowModal(false)}
        >
          <div
            className="relative max-w-4xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setShowModal(false)}
              className="absolute -top-10 right-0 w-8 h-8 flex items-center justify-center text-white hover:text-[#d4af37] transition-colors cursor-pointer"
            >
              <i className="ri-close-line text-3xl"></i>
            </button>
            <div className="rounded-2xl overflow-hidden shadow-2xl shadow-[#d4af37]/20 border border-[#d4af37]/30">
              <img
                src="https://static.readdy.ai/image/f4ea41724fdff553620ff2345610d616/11f9a79f82ae793ceda54b7f16ee41a0.jpeg"
                alt="Sample Certificate"
                className="w-full h-auto object-contain"
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
